import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'br_automation',
} as IModuleProps;
